import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon, LandmarkIcon, ShieldCheckIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
interface SinglePlanOfferProps {
  className?: string;
}
const inclusions = ['Página web profesional a medida', 'Carta digital clara y fácil de consultar', 'Diseño responsive para cada pantalla', 'Gestión y mantenimiento integral', 'Actualizaciones y soporte continuo', 'Sin cuotas ni costes ocultos'];
export function SinglePlanOffer({
  className = ''
}: SinglePlanOfferProps) {
  return <section className={`section-shell border-t border-white/10 bg-[#0a0a0a] ${className}`} aria-labelledby="offer-title" data-id="element-139" data-mp="1avrwj8yshjau">
      <div className="container mx-auto px-6 md:px-12" data-id="element-140" data-mp="16tdgsxqf2zns">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.5
      }} className="mx-auto max-w-6xl overflow-hidden border border-white/15" data-id="element-141" data-mp="2max70z55wm50">
          <div className="grid lg:grid-cols-[1.25fr_0.75fr]" data-id="element-142" data-mp="1yacg8w3bpk1j">
            <div className="bg-black p-8 sm:p-12" data-id="element-143" data-mp="1y8rmv9sqw759">
              <p className="eyebrow" data-id="element-144" data-mp="238w10t66kpsb">La oferta</p>
              <div className="mt-5 max-w-2xl" data-id="element-145" data-mp="237kzl007ju4d">
                <h2 id="offer-title" className="text-3xl font-medium tracking-[-0.045em] text-white sm:text-4xl" data-id="element-146" data-mp="16kprbruej776">
                  La base digital de tu negocio, resuelta en una sola propuesta.
                </h2>
                <p className="mt-5 text-sm leading-relaxed text-neutral-400 sm:text-base" data-id="element-147" data-mp="1kat7c12ou4o6">
                  Una oferta completa para poner orden, elevar la percepción de
                  tu marca y facilitar que las personas adecuadas den el
                  siguiente paso.
                </p>
              </div>
              <ul className="mt-9 grid gap-x-6 gap-y-4 border-t border-white/10 pt-7 sm:grid-cols-2" data-id="element-148" data-mp="1v4wb6k2jcc0c">
                {inclusions.map(inclusion => <li key={inclusion} className="flex items-start gap-3 text-sm leading-relaxed text-neutral-300" data-id="element-149" data-mp="1q4ichsmtqeez">
                    <CheckIcon size={16} className="mt-0.5 shrink-0 text-white" aria-hidden="true" data-id="element-150" data-mp="1zwxw0udrrb1z" />
                    {inclusion}
                  </li>)}
              </ul>
            </div>
            <div className="flex flex-col justify-between border-t border-white/10 bg-white p-8 text-black sm:p-12 lg:border-l lg:border-t-0" data-id="element-151" data-mp="1l8b4luavasue">
              <div data-id="element-152" data-mp="2wmooyp6ewq5o">
                <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-neutral-600" data-id="element-153" data-mp="2wm5hk2ee1k5w">
                  Pago único
                </p>
                <p className="mt-5 text-6xl font-medium tracking-[-0.07em]" data-id="element-154" data-mp="2rnc4uc6xdx6s">
                  350€
                </p>
                <p className="mt-4 text-sm leading-relaxed text-neutral-700" data-id="element-155" data-mp="306ywx7seba81">
                  Importe total por adelantado mediante transferencia bancaria.
                  El proyecto comienza al confirmar el pago.
                </p>
              </div>
              <div className="mt-10 border-t border-black/10 pt-6" data-id="element-156" data-mp="2v6ay3zxxdp39">
                <div className="space-y-3 text-xs text-neutral-700" data-id="element-157" data-mp="3iukeunga7mnj">
                  <p className="flex items-center gap-2" data-id="element-158" data-mp="3ixgdkdzyefd1">
                    <LandmarkIcon size={15} aria-hidden="true" data-id="element-159" data-mp="3nsvp2zahnz6a" /> Transferencia
                    bancaria
                  </p>
                  <p className="flex items-center gap-2" data-id="element-160" data-mp="3936igojmn2ym">
                    <ShieldCheckIcon size={15} aria-hidden="true" data-id="element-161" data-mp="3e3c5freyc1ad" /> Sin
                    suscripciones mensuales
                  </p>
                </div>
                <Link to="/checkout" className="group mt-7 flex w-full items-center justify-center gap-2 bg-black px-5 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-neutral-800 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2 focus-visible:ring-offset-white" data-id="element-162" data-mp="afag9pblozki">
                  Continuar al pago{' '}
                  <ArrowRightIcon size={16} className="transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-163" data-mp="23zm0vyw2te00" />
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}